import { iif, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export const getResult = (source: Observable<any>): Observable<any> => source.pipe(
    switchMap(response => <Observable<any>> iif(() => response === null || !response.hasOwnProperty('result'), of(Object.assign({}, { result: response })), of(response))),
    map(response => response.result)
);
